// @flow

import React from "react";
import { View, Text } from "@components";

type Props = {
  title: string,
  formStyle?: boolean,
  description: string,
  children: React.ReactNode,
};

export const BoxField = ({ title, description, formStyle, children }: Props) => {
  return (
    <View
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className="border-1px-charcoal-light"
      padding="0.5rem"
    >
      <View flex={formStyle ? 2 : null}>
        <Text type="strong">{title}</Text>
        <Text>{description}</Text>
      </View>
      <View flex={formStyle ? 1 : null}>{children}</View>
    </View>
  );
};
